import {Trans} from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {useLinkNavigation} from '../../../components/common/navigation/useLinkNavigation';
import {SettingsCustomFieldsPagesEnum} from '../../../models/url/settingsUrlModel';
import {settingsHorizontalSpacing} from '../../settingsCommonConstants';
import {getCustomFieldsBaseUrl} from '../customFieldsHelpers';

/*
 * Types.
 */

interface CustomFieldsButtonsProps {
  tabPage: SettingsCustomFieldsPagesEnum;
}

/*
 * Styles.
 */

const StyledDiv = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-left: ${settingsHorizontalSpacing}px;
`;

/*
 * Component.
 */

export const CustomFieldsButtons = ({tabPage}: CustomFieldsButtonsProps) => {
  const {navigateToLink} = useLinkNavigation();

  return (
    <StyledDiv>
      <Button
        variant={ButtonVariantsEnum.PRIMARY}
        onClick={() => navigateToLink(`${getCustomFieldsBaseUrl(tabPage)}/new`)}
      >
        {customFieldButtonTextMap[tabPage]}
      </Button>
    </StyledDiv>
  );
};

const customFieldButtonTextMap = {
  [SettingsCustomFieldsPagesEnum.TEAMMATES]: (
    <Trans id="settings-custom-fields-add-custom-field-teammate">Add teammate custom field</Trans>
  ),
  [SettingsCustomFieldsPagesEnum.INBOXES]: (
    <Trans id="settings-custom-fields-add-custom-field-inbox">Add inbox custom field</Trans>
  ),
  [SettingsCustomFieldsPagesEnum.CARDS]: (
    <Trans id="settings-custom-fields-add-custom-field-contact">Add contact custom field</Trans>
  ),
  [SettingsCustomFieldsPagesEnum.ACCOUNTS]: (
    <Trans id="settings-custom-fields-add-custom-field-account">Add account custom field</Trans>
  ),
};
